import {WritableSignal} from '@angular/core';
import {ISignCycle} from '@global-data';

import {IBaseValidationTest} from '../schemas';

export type ILivenessValidatorState = {
	sessionId: string; // the active signed cycle id
	tests: IBaseValidationTest[];
	signCycleModel$: WritableSignal<ISignCycle>;
};

export const livenessValidatorInitialState: ILivenessValidatorState = {
	sessionId: null,
	tests: null,
	signCycleModel$: null,
};
